<template>
	<div class="page__notifications">
		<div class="notifications" :class="[{'notifications--red': data.type === 'danger'}, {'notifications--yellow': data.type === 'warning'}, {'notifications--green': data.type === 'success'}]">
			<SvgIcon class="notifications__icon notifications__icon--exclamation" iconName="ico-exclamation-circle"/>
			<span class="notifications__text">{{ data.msg }}</span>
			<div class="popup-form__wrap-close-popup">
				<a @click="closeNotificaiton" v-if="data.hasCloseIcon">
					<SvgIcon class="close-icon" iconName="ico-close-sm"/>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		SvgIcon
	},
	methods: {
		closeNotificaiton() {
			this.$emit('closeNotificaiton');
		}
	}
};
</script>

<style lang="scss" scoped>
.close-icon {
	font-size: 11px;
	display: inline-block;
	transition: $dur $ease;
	position: absolute;
	top: 2px;
	right: 5px;
	height: 15px;
	cursor: pointer;

	@include mq($sm) {
		top: 2px;
		transform: none;
	}

	svg {
		height: 15px;
	}

	@include hover {
		color: $dodger-blue;
	}
}

.page__notifications {
	position: relative;
	@include mq($xl) {
		margin: 10px 0;
	}
}

.notifications {
	padding: 5px 26px;
	box-sizing: border-box;
    border-radius: 8px;
	max-width: 498px;
	display: flex;
	align-items: center;
	position: relative;

	@include mq(1600px) {
		max-width: 948px;
		width: 100%;
	}

	@include mq($sm) {
		align-items: flex-start;
	}
}

.notifications__text {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;

	@include mq($sm) {
		font-size: 13px;
	}
}

.notifications__icon--exclamation {
	margin-right: 6px;
	left: 9px;
}

.notifications__close {
	transition: $dur $ease;
	.notifications__icon {
		right: 9px;
	}

	@include hover {
		.notifications__icon {
			color: $dodger-blue;
		}
	}
}

.notifications__icon {
	font-size: 11px;
	display: inline-block;
	transition: $dur $ease;
	position: absolute;
	top: 6px;
	height: 15px;

	@include mq($sm) {
		top: 5px;
		transform: none;
	}

	svg {
		height: 15px;
	}
}
</style>
